import { CONFIG, KEYCODES } from '../config';
import { dispatchCustomEvent } from '../../tools/helpers';

class BfvZipSearch {
  constructor(options = {}) {
    this.$root = options.element;
    this.$inputWrapper = this.$root.querySelector('.input');
    this.$input = this.$root.getElementsByTagName('input')[0];
    this.$optionsWrapper = this.$root.getElementsByClassName('js-bfv-zip-options')[0];
    this.apiRoute = this.$root.getAttribute('data-api-url');
    this.minTrigger = parseInt(this.$root.getAttribute('data-min-trigger'), 10);
    this.data = {};
    this.focusedOption = null;
    this.hasFocus = false;
    this.lastKeyDel = false;

    this.keyDownHandler = this.handleKeyDown.bind(this);
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.$input.addEventListener('input', (evt) => {
      if (evt.target.value.length >= this.minTrigger) {
        this.loadData(encodeURIComponent(evt.target.value));
      } else {
        this.$optionsWrapper.classList.add('bfv-zip-search__results-wrapper--hidden');
        this.$optionsWrapper.innerHTML = '';
        this.$inputWrapper.classList.remove('input--error');
      }
    });

    this.$input.addEventListener('focus', () => {
      this.hasFocus = true;
      if (this.data.entries && this.data.entries.length > 0) {

        this.buildAutoComplete();
        this.$inputWrapper.classList.remove('input--error');
      }
    });

    this.bindCloseEvents();
  }

  /**
   * get the cities that contain the zip code
   * @param val
   */
  loadData(val) {
    window.divae.restApi
      .loadData(`${this.apiRoute}?s=${val}`, 'application/xhtml+xml')
      .then((_response) => {
        this.data = JSON.parse(_response);

        if (this.data.entries.length) {
          this.buildAutoComplete();
          this.$inputWrapper.classList.remove('input--error');
        } else {
          this.hideAutocomplete();
          this.$inputWrapper.classList.add('input--error');
          dispatchCustomEvent(CONFIG.events.BFV_ZIP_SEARCH_CHANGE, { valid: false });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  /**
   * create and display auto select
   */
  buildAutoComplete() {
    this.$optionsWrapper.innerHTML = '';
    this.$optionsWrapper.classList.remove('bfv-zip-search__results-wrapper--hidden');

    const optionsArray = [];
    Array.prototype.slice.call(this.data.entries).forEach((element) => {
      optionsArray.push(element);
    });

    // set value if only one option left
    if (optionsArray.length === 1 && !this.lastKeyDel) {
      const district = optionsArray[0].district !== null ? optionsArray[0].district : '';
      this.$input.value = `${optionsArray[0].id} ${optionsArray[0].city} ${district}`;
      this.$input.setAttribute('data-zip-value', optionsArray[0].id);
      this.hideAutocomplete();

      dispatchCustomEvent(CONFIG.events.BFV_ZIP_SEARCH_CHANGE, { valid: true });
    }

    for (let len = optionsArray.length; len >= 0; len -= 1) {
      if (optionsArray[len] !== undefined) {
        const opt = document.createElement('div');
        const district = optionsArray[len].district !== null ? optionsArray[len].district : '';
        opt.id = optionsArray[len].id;
        opt.setAttribute('data-zip', optionsArray[len].id);
        opt.tabIndex = -1;
        opt.innerText = `${optionsArray[len].id} ${optionsArray[len].city} ${district}`;
        opt.classList.add('bfv-zip-search__result-element');
        this.$optionsWrapper.insertBefore(opt, this.$optionsWrapper.firstChild);
      }
    }

    this.bindOptionEvents();
    this.bindKeyEvents();
  }

  /**
   * clear and hide auto select
   */
  hideAutocomplete() {
    this.$optionsWrapper.classList.add('bfv-zip-search__results-wrapper--hidden');
    this.$optionsWrapper.innerHTML = '';
    this.hasFocus = false;
  }

  /**
   * events for closing if clicking outside of auto select
   */
  bindCloseEvents() {
    // we want the $outside event be triggered by clicking on the input
    this.$input.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
    });

    window.addEventListener('click', (event) => {
      if (this.hasFocus === true && event.target !== this.$root) {
        this.hideAutocomplete();
        this.hasFocus = false;
        dispatchCustomEvent(CONFIG.events.BFV_ZIP_SEARCH_CHANGE, { valid: true });
      }
    });
  }

  /**
   * write selected zip, city & district into input and zip attribute to use in forms,
   * then close the dropdown
   */
  bindOptionEvents() {
    const $options = this.$optionsWrapper.getElementsByClassName('bfv-zip-search__result-element');

    [...$options].forEach(($option) => {
      $option.addEventListener('click', (event) => {
        event.stopPropagation();
        this.$input.value = event.target.innerText;
        this.$input.setAttribute('data-zip-value', event.target.dataset.zip);
        this.hideAutocomplete();
        dispatchCustomEvent(CONFIG.events.BFV_ZIP_SEARCH_CHANGE, { valid: true });
      });
    });
  }

  /**
   * binding events key down
   */
  bindKeyEvents() {
    this.$root.removeEventListener('keydown', this.keyDownHandler);
    this.$root.addEventListener('keydown', this.keyDownHandler);
  }

  /**
   * browse the dropdowns with arrow up and down keys
   * select with enter key
   * @param event
   */
  handleKeyDown(event) {
    const key = event.keyCode || event.which;
    const $options = this.$optionsWrapper.getElementsByClassName('bfv-zip-search__result-element');

    if (key === KEYCODES.DOWN) {
      if (this.focusedOption) {
        this.focusedOption = (this.focusedOption % $options.length) + 1;
      } else {
        this.focusedOption = 1;
      }
    }

    if (key === KEYCODES.UP) {
      if (this.focusedOption) {
        this.focusedOption = ((this.focusedOption - $options.length - 1) % $options.length) + $options.length;
      } else {
        this.focusedOption = $options.length;
      }
    }

    const $focusedOption = $options[this.focusedOption - 1];

    if (key === KEYCODES.DOWN || key === KEYCODES.UP) {
      event.preventDefault();
      $focusedOption.focus();
    }

    if (key === KEYCODES.ENTER) {
      if ($focusedOption !== undefined) {
        this.$input.value = $focusedOption.innerText;
      }

      this.$input.setAttribute('data-zip-value', event.target.dataset.zip);
      this.hideAutocomplete();
    }

    this.lastKeyDel = key === KEYCODES.DEL || key === KEYCODES.DEL2;
  }
}

export default BfvZipSearch;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvZipSearch/index.js